export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, впишите название', trigger: 'blur' },
    ],
    price: [
        { required: true, message: 'Пожалуйста, укажите стоимость', trigger: 'blur' },
        { min: 1, message: 'Пожалуйста, укажите стоимость', trigger: 'blur' },
    ],
};
